import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { RepliconDialog } from '~/modules/common/components';
import { useMeContext } from '~/modules/me';
import RemoveTaskEstimateConfirmationDialogContent from './RemoveTaskEstimateConfirmationDialogContent';
import RemoveTaskEstimateConfirmationDialogTitle from './RemoveTaskEstimateConfirmationDialogTitle';
import RemoveTaskEstimateConfirmationDialogFooter from './RemoveTaskEstimateConfirmationDialogFooter';

const useDialogStyles = makeStyles(theme => ({
  paper: {
    maxWidth: theme.spacing(90)
  }
}));

const RemoveTaskEstimateConfirmationDialog = ({
  open,
  onClose,
  task,
  resourceEstimate,
  onRemoveResourceEstimateSuccess
}) => {
  const dialogClasses = useDialogStyles();

  const {
    featureFlags: { isPsaRmp2025Q4WcagEnabled }
  } = useMeContext();

  const DialogComponent = isPsaRmp2025Q4WcagEnabled ? RepliconDialog : Dialog;

  return (
    <DialogComponent
      classes={dialogClasses}
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="remove-task-estimate-confirmation-dialog-title"
      aria-describedby="remove-task-estimate-confirmation-dialog-description"
    >
      <RemoveTaskEstimateConfirmationDialogTitle
        taskName={task.name}
        isParentTask={task.hasChildren}
      />
      <RemoveTaskEstimateConfirmationDialogContent
        resourceEstimate={resourceEstimate}
        task={task}
      />
      <RemoveTaskEstimateConfirmationDialogFooter
        onClose={onClose}
        projectId={task.projectReference.id}
        taskId={task.id}
        resourceEstimateId={resourceEstimate.id}
        onRemoveResourceEstimateSuccess={onRemoveResourceEstimateSuccess}
      />
    </DialogComponent>
  );
};

RemoveTaskEstimateConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  task: PropTypes.object,
  resourceEstimate: PropTypes.object,
  onRemoveResourceEstimateSuccess: PropTypes.func
};

export default RemoveTaskEstimateConfirmationDialog;
